// Usulan Cetak store — sekarang tersimpan di DB (gapfamily / gapintegrity),
// bukan localStorage lagi. Semua method async (mengembalikan Promise).

import { gapfamilyApi } from '../../services/api';
import { TENANTS } from '../../services/sursysLogisticAPI';

export const SPK_STATUS = {
  DRAFT:         { label: 'Draft',            color: '#64748b', bg: '#f1f5f9', step: 0 },
  DICETAK:       { label: 'Dicetak',          color: '#7c3aed', bg: '#ede9fe', step: 1 },
  IN_PRODUCTION: { label: 'In Production',    color: '#d97706', bg: '#fef3c7', step: 2 },
  SELESAI:       { label: 'Selesai Produksi', color: '#059669', bg: '#d1fae5', step: 3 },
  DIKIRIM:       { label: 'Dikirim',          color: '#2563eb', bg: '#dbeafe', step: 4 },
  DITERIMA:      { label: 'Diterima Cabang',  color: '#16a34a', bg: '#dcfce7', step: 5 },
};

const companyId = () => TENANTS.SUMA.company_id;
const unwrap = (data) => data?.data ?? data;
const n = (v) => { const x = parseFloat(v); return Number.isFinite(x) ? x : 0; };

// Map baris DB (snake_case) → bentuk yang dipakai UI (camelCase).
const mapSpk = (u) => ({
  id: u.id,
  kode: u.kode,
  nama: u.nama,
  satuan: u.satuan,
  kategori: u.kategori,
  defisitNasional: n(u.defisit_nasional),
  qtyProduksi: n(u.qty_produksi),
  pic: u.pic || 'Admin',
  status: u.status,
  jobNumber: u.job_number || '',
  catatanKirim: u.catatan_kirim || '',
  printCount: u.print_count || 0,
  createdAt: u.created_at,
  defisitCabang: (u.cabang || []).map((c) => ({
    cabang: c.cabang, stok: n(c.stok), sp: n(c.sp_belum), selisih: n(c.selisih),
  })),
  timeline: (u.timeline || []).map((t) => ({ time: t.at, action: t.action, by: t.actor })),
});

export const spkStore = {
  getAll: async () => {
    try {
      const { data } = await gapfamilyApi.get('/usulan-cetak', { params: { company_id: companyId() } });
      return (unwrap(data) || []).map(mapSpk);
    } catch (e) { console.error('spkStore.getAll', e); return []; }
  },

  getByKode: async (kode) => {
    const all = await spkStore.getAll();
    return all.find((s) => s.kode === kode && s.status !== 'DITERIMA');
  },

  create: async ({ kode, nama, satuan, kategori, defisitNasional, defisitCabang, qtyProduksi, pic }) => {
    const body = {
      company_id: companyId(), kode, nama, satuan, kategori,
      defisit_nasional: defisitNasional, qty_produksi: qtyProduksi, pic,
      cabang: (defisitCabang || []).map((c) => ({ cabang: c.cabang, stok: c.stok, sp: c.sp, selisih: c.selisih })),
    };
    const { data } = await gapfamilyApi.post('/usulan-cetak', body);
    return mapSpk(unwrap(data));
  },

  print: async (id) => {
    const { data } = await gapfamilyApi.post(`/usulan-cetak/${id}/print`);
    return mapSpk(unwrap(data));
  },

  setJobNumber: async (id, jobNumber) => {
    const { data } = await gapfamilyApi.patch(`/usulan-cetak/${id}/job`, { job_number: jobNumber });
    return mapSpk(unwrap(data));
  },

  setSelesai: async (id) => {
    const { data } = await gapfamilyApi.patch(`/usulan-cetak/${id}/status`, { status: 'SELESAI' });
    return mapSpk(unwrap(data));
  },

  setDikirim: async (id, catatanKirim) => {
    const { data } = await gapfamilyApi.patch(`/usulan-cetak/${id}/status`, { status: 'DIKIRIM', catatan: catatanKirim });
    return mapSpk(unwrap(data));
  },

  setDiterima: async (id) => {
    const { data } = await gapfamilyApi.patch(`/usulan-cetak/${id}/status`, { status: 'DITERIMA' });
    return mapSpk(unwrap(data));
  },

  delete: async (id) => { await gapfamilyApi.delete(`/usulan-cetak/${id}`); },
};
